import { render, staticRenderFns } from "./CreateProductsPage.vue?vue&type=template&id=52b13616&"
import script from "./CreateProductsPage.vue?vue&type=script&lang=js&"
export * from "./CreateProductsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports